export const AUTOSAVE_STATUS = Object.freeze({
    IDLE: 'idle',
    PENDING: 'pending',
    SAVING: 'saving',
    SAVED: 'saved',
    ERROR: 'error',
});
